import { render } from "./NotFound.vue?vue&type=template&id=4f031923"
const script = {}

import exportComponent from "C:\\Dev\\CCERWB\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__